import { getIdv2InitialValues, getIdv2StoreData, setIdv2StoreData } from './idv2-provider';

/**
 * Mark that transfer has been completed, preventing redirect loops when user completes transfer or chooses "Continue on desktop".
 * Should only be called when transfer actually finishes (not on entry).
 */
export const markTransferVisited = () => {
  setIdv2StoreData({ isTransferVisited: true });
};

export const isTransferVisited = (): boolean => {
  return getIdv2StoreData()?.isTransferVisited ?? false;
};

/**
 * Mark that user chose "Continue on mobile" on document collection page.
 * This allows re-entry to transfer even though transfer was already visited.
 */
export const markContinueOnMobile = () => {
  setIdv2StoreData({ continueOnMobile: true });
};

export const isContinueOnMobile = (): boolean => {
  return getIdv2StoreData()?.continueOnMobile ?? false;
};

/**
 * Consume the continueOnMobile flag when entering transfer.
 * This flag is set when the user clicks "Continue on mobile" during document collection,
 * and should be reset once transfer is entered so it's not reused.
 */
export const consumeContinueOnMobile = () => {
  setIdv2StoreData({ continueOnMobile: false });
};

/**
 * Whether this session is running inside a transfer handoff (new tab opened from transfer).
 * When true, transfer should be skipped to avoid showing the QR/transfer screen again in the new tab.
 */
export const isTransferSession = (): boolean => {
  return getIdv2InitialValues()?.isTransfer ?? false;
};
